import { createFileRoute } from '@tanstack/react-router'
import AdminFeatureFlagsPage from '@/components/pages/Admin/AdminFeatureFlagsPage/AdminFeatureFlagsPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/feature-flags')({
  component: AdminFeatureFlagsRoute,
})

function AdminFeatureFlagsRoute() {
  return <AdminFeatureFlagsPage />
}
